import React, { FC } from 'react';
import styled from 'styled-components';
import App from '../../../models/app';

import { translations } from 'i18n';
import { BannerContainer } from '../ImageContainer/BannerContainer';
import { Link } from '../Common';
import Typography from '../Typography';
import { buttonBarStyles } from '../Button/ButtonBar';

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BannerInfoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const BannerDiv = styled.div`
  width: 75px;
  height: 75px;
  flex-shrink: 0;

  background: var(--sys-color--surface);
  box-sizing: border-box;
  border-radius: 14px;
`;

const CenterContent = styled.div`
  flex-grow: 1;
  min-width: 0px;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const AppTitle = styled(Typography)`
  padding: 3px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const DeveloperName = styled(Typography)`
  padding: 3px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const DecorativeTextButton = styled.div<{
  $variant: 'filled' | 'outline' | 'text';
  $compact?: boolean;
  $fullWidth?: boolean;
}>`
  ${buttonBarStyles}
  padding: 0;
`;

interface ParentAppSectionProps {
  app: App;
}

const ParentAppSection: FC<ParentAppSectionProps> = (props) => {
  const { app } = props;
  const screenshot = app.icon;

  return (
    <SectionContainer>
      <Link
        to={`/v2/app/${app.id}`}
        pageDirection='FORWARD'
        id={'tiles-parent-app'}
        aria-label={'tiles-parent-app'}
      >
        <BannerInfoContainer>
          <BannerDiv>
            <BannerContainer
              containerAttr={{
                width: screenshot.width,
                height: screenshot.height,
              } as any}
              imageAttr={{
                src: screenshot.uri,
                alt: app.name,
              }}
            />
          </BannerDiv>
          <CenterContent>
            <AppTitle variant="labelLarge" color="var(--sys-color--on-surface-variant)">
              {app.name}
            </AppTitle>
            <DeveloperName variant="bodyMedium" color="var(--sys-color--on-surface-variant)">
              {app.developer.name}
            </DeveloperName>
          </CenterContent>
          <DecorativeTextButton $variant="text" $compact={true}>
            Go to the app
          </DecorativeTextButton>
        </BannerInfoContainer>
      </Link>
    </SectionContainer>
  )
}

export default ParentAppSection;
